// NOSTALGIC MISFITS — main.js v2.0

(function() {
  'use strict';

  // Custom cursor dot
  var dot = document.createElement('div');
  dot.className = 'cursor-dot';
  document.body.appendChild(dot);

  document.addEventListener('mousemove', function(e) {
    dot.style.left = e.clientX + 'px';
    dot.style.top = e.clientY + 'px';
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(function(a) {
    a.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Lazy-load fade-in for images
  if ('IntersectionObserver' in window) {
    var imgObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          imgObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.product-card, .gallery-item').forEach(function(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      imgObserver.observe(el);
    });
  }

  // Add to cart feedback
  var atcBtn = document.getElementById('add-to-cart-btn');
  if (atcBtn) {
    var form = document.getElementById('product-form');
    if (form) {
      form.addEventListener('submit', function(e) {
        atcBtn.textContent = 'Added ✦';
        atcBtn.style.background = 'var(--red)';
        atcBtn.style.color = 'var(--white)';
        setTimeout(function() {
          atcBtn.textContent = 'Add to Cart';
          atcBtn.style.background = '';
          atcBtn.style.color = '';
        }, 2000);
      });
    }
  }

})();
